interface Task<T> {
  run: () => Promise<T>;
  resolve: (value: T) => void;
  reject: (error: Error) => void;
}

class Queue<T> {
  private tasks: Task<T>[] = [];

  enqueue(run: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.tasks.push({ run, resolve, reject });

      if (this.tasks.length === 1) {
        this.dequeue();
      }
    });
  }

  private async dequeue() {
    const task = this.tasks.at(0);
    if (!task) return;

    try {
      const result = await task.run();
      task.resolve(result);
    } catch (error) {
      task.reject(error);
    }

    this.tasks.shift();
    this.dequeue();
  }
}

export default Queue;
